// extracted by mini-css-extract-plugin
export default {"box":"box__4xNYm","bold":"bold__yf99x","subtitle":"subtitle__kMM9f"};